const img = require('./porchSideB_active.svg'); export default img;